module.exports = __webpack_public_path__ + "img/horizontal_4_7_9006.dec8fece.png";